import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';
import CheckboxGroupInput from 'common/components/CheckboxGroupInput';
import DebouncedInputField from 'common/components/DebouncedInputField';
import SearchActionCreators from 'search/actions/SearchActionCreators';

class SearchFilters extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      et: PropTypes.number,
      people: PropTypes.string,
      people_filter: PropTypes.string,
      location: PropTypes.string,
      vs: PropTypes.array,
      title: PropTypes.title
    }).isRequired,
    eventTypes: PropTypes.array.isRequired,
    venueServices: PropTypes.array
  };

  render() {
    return (
      <div className="m-search-filters">
        <div className="m-search-filters-main-section">
          <div className="m-search-filters-main-label">
            <label htmlFor="eventTypes">
              <i className="fa fa-tags m-search-filters-main-icon" />
              {__('search.search_filters.event_types.label')}
            </label>
          </div>
          <div className="m-search-filters-main-large">
            <select
              id="eventTypes"
              ref="eventTypeSelect"
              value={this.props.params.et}
              onChange={this._onEventTypeChange}
            >
              <option value="">
                {__('search.search_filters.event_types.placeholder')}
              </option>
              {this.props.eventTypes.map(eventType => {
                return (
                  <option
                    value={eventType.id}
                    key={`event-type:${eventType.id}`}
                  >
                    {eventType.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="m-search-filters-main-section">
          <div className="m-search-filters-main-label">
            <label htmlFor="people">
              <i className="fa fa-home m-search-filters-main-icon" />
              {__('search.search_filters.people.label')}
            </label>
          </div>
          <div className="m-search-filters-main-small">
            <select
              id="people"
              ref="peopleSelect"
              value={this.props.params.people}
              onChange={this._onPeopleChange}
            >
              <option value="">
                {__('search.search_filters.people.placeholder')}
              </option>
              {this.props.capacityRanges.map(range => {
                return (
                  <option value={range[1]} key={`capacity-range:${range[1]}`}>
                    {range[0]}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="m-search-filters-main-small">
            <select
              ref="peopleFilterSelect"
              value={this.props.params.people_filter}
              onChange={this._onPeopleFilterChange}
            >
              <option value="">
                {__('search.search_filters.people_filter.sitting')}
              </option>
              <option value="standing">
                {__('search.search_filters.people_filter.standing')}
              </option>
            </select>
          </div>
        </div>
        <div className="m-search-filters-main-section">
          <div className="m-search-filters-main-label">
            <label htmlFor="location">
              <i className="fa fa-map-marker m-search-filters-main-icon" />
              {__('search.search_filters.location.label')}
            </label>
          </div>
          <div className="m-search-filters-main-large">
            <DebouncedInputField
              type="text"
              id="location"
              ref="locationInput"
              placeholder={__('search.search_filters.location.placeholder')}
              value={this.props.params.location}
              onChange={this._onLocationChange}
            />
          </div>
        </div>
        <div className="m-search-filters-main-section">
          <div className="m-search-filters-main-label">
            <label>
              <i className="fa fa-reorder m-search-filters-main-icon" />
              {__('search.search_filters.venue_services.label')}
            </label>
          </div>
          <div className="m-search-filters-main-large m-checkbox-list m-checkbox-list-small">
            <CheckboxGroupInput
              values={this.props.venueServices}
              selectedValues={this.props.params.vs}
              onChange={this._onVenueServicesChange}
              ref="venueServicesCheckboxGroup"
            />
          </div>
        </div>
        <div className="m-search-filters-main-section">
          <div className="m-search-filters-main-label">
            <label htmlFor="title">
              <i className="fa fa-search m-search-filters-main-icon" />
              {__('search.search_filters.title.label')}
            </label>
          </div>
          <div className="m-search-filters-main-large">
            <DebouncedInputField
              type="text"
              id="title"
              ref="titleInput"
              placeholder={__('search.search_filters.title.placeholder')}
              value={this.props.params.title}
              onChange={this._onTitleChange}
            />
          </div>
        </div>
      </div>
    );
  }

  _onTitleChange = () => {
    const title = findDOMNode(this.refs.titleInput).value;
    SearchActionCreators.changeVenueTitleFilter(title);
  };

  _onVenueServicesChange = () => {
    const venueServices = this.refs.venueServicesCheckboxGroup.getSelectedValues();
    SearchActionCreators.changeVenueServicesFilter(venueServices);
  };

  _onEventTypeChange = () => {
    const selectedEventType = findDOMNode(this.refs.eventTypeSelect).value;
    SearchActionCreators.changeEventTypeFilter(selectedEventType);
  };

  _onPeopleChange = () => {
    const peopleAmount = findDOMNode(this.refs.peopleSelect).value;
    SearchActionCreators.changePeopleFilter(peopleAmount);
  };

  _onPeopleFilterChange = () => {
    const peopleFilter = findDOMNode(this.refs.peopleFilterSelect).value;
    // TODO: Come up with a better name #peoplefilter
    SearchActionCreators.changePeopleFilterFilter(peopleFilter);
  };

  _onLocationChange = () => {
    const location = findDOMNode(this.refs.locationInput).value;
    SearchActionCreators.changeLocationFilter(location);
  };
}

export default SearchFilters;
